import { useEffect, useState } from 'react';

// True while the element is on screen. Starts true so nothing flashes before the first callback.
const useInView = (ref, enabled = true) => {
  const [inView, setInView] = useState(true);

  useEffect(() => {
    if (!enabled || !ref.current || typeof IntersectionObserver === 'undefined') return undefined;

    const observer = new IntersectionObserver(([entry]) => setInView(entry.isIntersecting));
    observer.observe(ref.current);
    return () => observer.disconnect();
  }, [ref, enabled]);

  return inView;
};

export default useInView;
